var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wt-box',{class:_vm.classes,attrs:{"direction":"row"}},[_c('div',{staticClass:"wt-segment-symbol__line"}),_c('div',{staticClass:"wt-segment-symbol__content",style:(`margin:0 ${_vm.gap}`)},[_vm._t("default")],2),_c('div',{staticClass:"wt-segment-symbol__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }